import { SearchtoolboxService } from './_services/searchtoolbox.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router ,NavigationEnd  } from '@angular/router';
import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { LoginService } from './_services/login.service';
import { interval } from 'rxjs';
import { GlobalService } from './_services/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TeaminviteComponent } from './teaminvite/teaminvite.component';
import { TransactionService } from './_services/transaction.service';
declare const clevertap;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'ats-crm-frontend';
  signupForm: Boolean
  searchtoolScreen: Boolean
  userid :any
  totalGrabbedCandidate: any;
  routeCheckForScrollNavabar:boolean
  removeContentPadding:boolean=false
  removeContentPaddingFreeTrial:boolean =false
  /** Routes that doesn't require authorization token */
  openRoutes:string[] = [
    '/login',
    '/set-password'
  ]
  constructor(private location: Location ,private router: Router ,private localstorageservice:LocalStorageService,
    private loginService: LoginService ,private searchservice : SearchtoolboxService, private globalService: GlobalService,
    private modalService: NgbModal, private transactionService: TransactionService) {

    //to check after every route change
    this.router.events.subscribe((xd) => {
      if (xd instanceof NavigationEnd) {
        if (location.path() == '/signup' || location.path() == '/login' || location.path() == '/feedback' || location.path() == '' || location.path().indexOf('login') > -1
        || location.path().indexOf('resetpassword') > -1  || location.path().indexOf('forgetpassword') > -1 || location.path().indexOf('iframe-searchtoolbox') > -1
        || router.url.includes('signup') || router.url.includes('set-password') || router.url.includes('teaminvite') || router.url.includes('expiry')) {
          this.signupForm = true
        } else {
          this.signupForm = false
        }
        this.fetchCreditsOnce();
        if(location.path() == '/searchtoolbox-v2'){
          this.searchtoolScreen = true
        }else{
          this.searchtoolScreen = false
        }
        this.checkGrabStatus()
        this.sendMessagetoChrome();
        if(!router.url.includes('try-talent-insights')) {
          const script = document.createElement('script');
      script.src = '//in.fw-cdn.com/31396676/675114.js';
      document.body.appendChild(script);
        }
        if(router.url.includes('signup') || router.url.includes('login') || router.url.includes('try-talent-insights') || window.location.pathname.includes('talent-insights-sourcing-tool')
        || window.location.pathname.includes('talent-insights-free-trial') || window.location.pathname.includes('resume-screener') || window.location.pathname.includes('skills-taxonomy-free-trial') ){
         // document.getElementById('warning-message').classList.add('d-none')
          document.getElementById('wrapper').classList.add('d-block')
        }else{
          document.getElementById('wrapper').classList.remove('d-block')
        }
        if(this.router.url.includes('person/search/listing')){
          this.routeCheckForScrollNavabar=true
        }else{
          this.routeCheckForScrollNavabar=false
        }


      }
    });
  }

  loadApplication: boolean = false;
  private creditsFetched: boolean = false;

  ngAfterViewInit(){
    setTimeout(()=>{
      this.sendMessagetoChrome()
    },1000)
  }

  ngOnInit(): void {
    // on the fly token
    // this.sendClevertapProfile()
    let token = sessionStorage.getItem('token');
    let emit = sessionStorage.getItem('emit');
    if (!token || !emit) {
      let data = { agent: window.navigator.userAgent };
      this.loginService.ontheflytoken(data)
      .subscribe((res: any) => {
       if (res.message && res.message.token) {

        if(this.localstorageservice.getItem('token') && !sessionStorage.getItem('token'))
          this.loginService.userSessionTracker().subscribe();

        // save token in local storage
        sessionStorage.setItem('token', res.message.token);

        // save current time in local storage
        sessionStorage.setItem('emit', `${+new Date()}`);

        // complete getting response from api then load the application
        this.loadApplication = true;
       } else {
        console.log('Something went wrong');
        this.loadApplication = true;
       }
      });
    } else {
      this.loadApplication = true;
    }
    this.searchservice.getGrabCandidateData().subscribe((res: any) => {
        if(res.profileurlsarray && res.profileurlsarray.length){
          this.localstorageservice.setItem('totalgrabcandidate',res.profileurlsarray.length)
          this.checkGrabStatus()
        }
    })

    // listen to route changes
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // trigger tour-modal conditionally except for login-route
        if( this.openRoutes.some(el => event.url.includes(el))) return;

        if(event.url.includes('/try-talent-insights')){
          this.removeContentPadding = true;
        }else{
          this.removeContentPadding = false;
        }
        if(event.url.includes('/talent-insights-free-trial') || event.url.includes('/skills-taxonomy-free-trial') ||  event.url.includes('/resume-screener')){
          this.removeContentPaddingFreeTrial = true;
        }else{
          this.removeContentPaddingFreeTrial = false;
        }

        const userData = this.localstorageservice.getItem('userdata');
        const invitationModel = JSON.parse(localStorage.getItem('teaminviteurl'));
        setTimeout(() => {
          if (invitationModel && userData) {
            const inviteModalRef = this.modalService.open(TeaminviteComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
            inviteModalRef.componentInstance.invitationModel = invitationModel;
          };
        }, 2000);

        setTimeout(() => {
          if(userData && !userData.istourcompleted) {
            const tourModalRef = this.globalService.openTourModal();
            tourModalRef.result.then((returnMessage: string) => {
              if(returnMessage === 'NO_UPDATE') return;

              if(userData.istourcompleted) return;

              const isglsession = this.localstorageservice.getItem('isglsession');
              const activityLog = [{
                updatedfieldname: "'istourcompleted'",
                oldvalue: "'" + Number(!!userData.istourcompleted) + "'",
                newvalue: "'1'"
              }]
              this.loginService.updateuserDetails({ usernumber: userData.usernumber, istourcompleted: 1, activitylog: !isglsession ? activityLog : [] }).subscribe((res: any) => {
                if (res.status == "success") {
                  userData.istourcompleted = 1;
                  this.localstorageservice.setItem('userdata', userData);
                }
              });
            })
          }
        }, 2000);
      }
    })
  }

  /**
   * Fetch the current user's credits exactly once per app lifetime - on refresh (first
   * NavigationEnd) or right after login (next NavigationEnd once the user lands on a page).
   * Subsequent credit refreshes happen via CreditActivityService (TransactionService's own
   * subscription) after a credit-consuming action, so this only needs to run the first time.
   */
  private fetchCreditsOnce(): void {
    if (this.creditsFetched || !this.localstorageservice.getItem('usernumber')) return;
    this.creditsFetched = true;
    this.transactionService.updateAllCreditsForCurrentUser().subscribe();
    this.transactionService.updateAccessDetailsForCurrentUser(true).subscribe();
  }

  checkGrabStatus() {
    if (this.localstorageservice.getItem('totalgrabcandidate') > 0) {
      this.totalGrabbedCandidate = this.localstorageservice.getItem('totalgrabcandidate')
      interval(30000).subscribe(x => {
        this.searchservice.bulkextractionstatus().subscribe((res: any) => {
          if (res.bulkextractioninprogress == false) {
            this.localstorageservice.setItem('totalgrabcandidate', 0)
            this.totalGrabbedCandidate = null
          }
        })
      });
    } else {
      this.localstorageservice.setItem('totalgrabcandidate', 0)
      this.totalGrabbedCandidate = null
    }
  }

  sendMessagetoChrome(){
    let chromeid = localStorage.getItem('extensionID');
    if (chromeid) {
      try {
        window?.['chrome']?.runtime?.sendMessage(chromeid, {
          action: 'login',
          usernumber: this.localstorageservice.getItem('usernumber'),
          userid: this.localstorageservice.getItem('userid'),
          firstname: this.localstorageservice.getItem('ufname'),
          lastname: this.localstorageservice.getItem('ulname'),
          token: this.localstorageservice.getItem('token'),
          userdata: this.localstorageservice.getItem('userdata')
        });
      } catch (error) {
        console.error('Here is the error message', error);
      }
    }
  }

  sendClevertapProfile(){
    let userdata = this.localstorageservice.getItem('userdata');
    const userPlanData = this.localstorageservice.getItem('userPlanData');
    if(userdata){
      let phone = userdata.extn ? "+91"+userdata.extn : "";
      let userprofile = {
        "Identity": userdata.userid,
        "First Name": userdata.firstname,
        "Last Name": userdata.lastname,
        "Email": userdata.loginemail,
        "Company": userdata.company,
        "Team Member": userPlanData?.isteammember ? "Yes": "No",
        "Role Type": userdata.role,
        "Plan Type": userPlanData?.plantype,
        "Plan Name": userPlanData?.paymentplanname,
        "Last Login": userdata.lastlogintime,
        "Contact credits balaance": userdata.balancebasiccontactenrichmentcredits,
        "User Type": userdata.usertypename
        }
     // clevertap.enableLocalStorageEncryption(true);
      clevertap.onUserLogin.push({ "Site": userprofile });
    }
  }
}

